import { Container, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { RolesValidator } from '../../../../validations/RolesValidator';
import { ROLE } from '../../../../utils/ROLE';
import { MenuDayDeclarationBlock } from './blocks/MenuDayDeclarationBlock';
import { ClientConfigsBlock } from './blocks/ClientConfigsBlock';
import { GroupsAndBudgetBlock } from './blocks/GroupsAndBudgetBlock';
import { PasswordBlock } from './blocks/PasswordBlock';
import { DoRender } from '../../../../utils/DoRender';

const UserSettingsPage = () => {

    const { t } = useTranslation('settings');

    return (
        <div className={'bdsm-selection-tabs--wrapper'}>
            <Container>
                <Tabs
                    id='settings-tabs'
                    className='mb-3 bdsm-selection-tabs'
                    mountOnEnter={true}
                    fill>
                    {DoRender(
                        RolesValidator([ROLE.DIETIST, ROLE.MANAGER]),
                        <Tab eventKey='ProductsReceiver' title={t('productsReceiver.title')}>
                            <ClientConfigsBlock />
                        </Tab>)}
                    {DoRender(
                        RolesValidator([ROLE.DIETIST, ROLE.MANAGER]),
                        <Tab eventKey='groupsAndBudget' title={t('groupsAndBudget.title')}>
                            <GroupsAndBudgetBlock />
                        </Tab>)}
                    {DoRender(
                        RolesValidator([ROLE.DIETIST]),
                        <Tab eventKey='menuDayDeclaration' title={t('menuDayDeclaration.title')}>
                            <MenuDayDeclarationBlock />
                        </Tab>)}
                    <Tab eventKey='changePassword' title={t('changePassword.title')}>
                        <PasswordBlock />
                    </Tab>
                </Tabs>
            </Container>
        </div>
    );
};

export default UserSettingsPage;